import { render, staticRenderFns } from "./header-create-menu.vue?vue&type=template&id=104d12f4&scoped=true&"
import script from "./header-create-menu.vue?vue&type=script&lang=js&"
export * from "./header-create-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-create-menu.vue?vue&type=style&index=0&id=104d12f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d12f4",
  null
  
)

/* custom blocks */
import block0 from "./header-create-menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports